import React from 'react'
import WidgetSelector from './WidgetSelector'

export default function WidgetBankAccountSelector(props) {
  const {
    value,
    displayValue,
    bank_accounts,
    onChange,
    viewOnly,
    reloadDropdownData,
    size,
  } = props
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
        selectedValue={value}
        displayValue={displayValue}
        options={bank_accounts}
        onChange={(values) => onChange(values)}
        reloadDropdownData={() => reloadDropdownData()}
        placeHolder="Select Bank Account"
        showCloudIcon={true}
        size={size}
      />
    </React.Fragment>
  )
}
